import { useMutation, useQuery } from "@tanstack/react-query";
import { CONFIG } from "../util/config";

export function useIpDetails() {
  return useQuery(
    ["ip-details"],
    () =>
      fetch("https://pro.ip-api.com/json?key=3pQZfl587vsCBcB").then(
        async (res) => {
          const data = await res.json();
          if (!res.ok) {
            return Promise.reject(data);
          }
          return data;
        },
      ),
    {
      initialData: undefined,
      staleTime: Infinity,
      refetchOnMount: false,
      retry: false,
      retryOnMount: false,
    },
  );
}

export async function getGeoLocation() {
  const API_KEY = "3pQZfl587vsCBcB";
  const endpoint = `https://pro.ip-api.com/json?key=${API_KEY}`;

  try {
    const response = await fetch(endpoint);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();

    if (data.status !== "success") {
      throw new Error(`API error: ${data.message || "Unknown error"}`);
    }

    return data;
  } catch (error) {
    console.error("Failed to fetch geolocation:", error);
    return null;
  }
}

export async function GetStatesByCountry({ ...config }) {
  return useMutation(async ({ country }) => {
    const url = "https://api.countrystatecity.in/v1/countries";
    const requestConfig = {
      method: "GET",
      headers: {
        "X-CSCAPI-KEY": CONFIG.statesApiKey,
      },
    };
    const res = await fetch(url, requestConfig);
    if (!res.ok) {
      const errorData = await res.json();
      throw new Error(errorData?.message || "Failed to fetch states");
    }
    await res.json();
  });
}
